import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import ExpandableProductList from "@components/ExpandableProductList";
import Heading from "@components/Heading";
import { getCatalogPromotions } from "@store/pages/actions";

const NoSearchResultsRecommendations = ({
  onProductClick,
  getCatalogPromotions,
}) => {
  const [productRecommendations, setProductRecommendations] = useState();

  useEffect(() => {
    const getProductRecommendations = async () => {
      // 5 as payload will fetch only promotions and top offers
      const response = await getCatalogPromotions(5);
      if (response?.data) setProductRecommendations(response.data);
    };

    getProductRecommendations();
  }, [getCatalogPromotions]);

  if (!productRecommendations) return null;

  return (
    <>
      {productRecommendations.promotions?.length > 0 && (
        <>
          <Heading
            as="h2"
            display="h1"
            title="Promotii"
            classesProp="mb-4 pt-6"
          />

          <ExpandableProductList
            products={productRecommendations.promotions.map(
              (product, index) => ({
                ...product,
                index: index + 1,
                item_list_name: "promotii",
              })
            )}
            desktopVisibleProducts={10}
            onProductClick={(product) => onProductClick(product)}
          />
        </>
      )}

      {productRecommendations.top_offer?.length > 0 && (
        <>
          <Heading
            as="h2"
            display="h1"
            title="Top oferte"
            classesProp="mb-4 pt-6"
          />

          <ExpandableProductList
            products={productRecommendations.top_offer.map(
              (product, index) => ({
                ...product,
                index: index + 1,
                item_list_name: "top oferte",
              })
            )}
            desktopVisibleProducts={10}
            onProductClick={(product) => onProductClick(product)}
          />
        </>
      )}
    </>
  );
};

NoSearchResultsRecommendations.propTypes = {
  onProductClick: PropTypes.func.isRequired,
};

export default connect(null, { getCatalogPromotions })(
  NoSearchResultsRecommendations
);
